export const colorHexValues: Record<string, string> = {
  Beige: '#F2EEDE',
  Black: '#000000',
  Blue: '#228BE6',
  Brown: '#663500',
  Gold: 'linear-gradient(225deg, #D9B561 18.76%, #DDBC67 24.71%, #E9CE79 31.23%, #EFD982 34.44%, #F9EA99 42.65%, #FDF2A2 46.24%, #FBF0A2 50.49%, #F3E294 59.94%, #EAD07C 68.82%, #DEBE6B 77.52%, #D1AB59 87.5%)',
  Gray: '#6A737D',
  Green: '#13BF6D',
  Orange: '#FF9523',
  Pink: '#F783AC',
  Purple: '#9775FA',
  Red: '#E03131',
  Silver:
    'linear-gradient(225deg, #BEC0C5 16.76%, #C6CACD 20.58%, #CFD3D6 26.87%, #D8DCDF 33.58%, #E5E9EC 42.17%, #EFF3F4 47.14%, #E8ECED 51.72%, #D8DDE0 62.16%, #CBD1D5 70.63%, #B9BEC4 77.23%, #A1A7AF 86.11%)',
  Tan: '#D6B588',
  White: '#ffffff',
  Yellow: '#FFD43B'
};
